import { render, staticRenderFns } from "./selectPriceModal.vue?vue&type=template&id=5a7a1924&"
import script from "./selectPriceModal.vue?vue&type=script&lang=js&"
export * from "./selectPriceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports